export var getRenderData = function (values, type, property) {
    return type ? Object.entries(values[type][property]) : Object.entries(values[property]);
};
export var fields = {
    equity: 'eq',
    ev: 'ev',
    eqr: 'eqr',
    range: 'abs',
    actions: 'abs',
};
export var previewSections = {
    presets: {
        matrixStrategy: true,
        matrixRange: true,
        matrixEv: true,
        matrixEq: true,
        matrixEqr: false,
        cells: true,
        detailMatrix: true,
        equityLine: true,
        gradientLine: false,
        cards: true,
        table: true,
        positions: true,
    },
    strategy: {
        matrixStrategy: true,
        matrixRange: false,
        matrixEv: false,
        matrixEq: false,
        matrixEqr: false,
        cells: true,
        detailMatrix: true,
        equityLine: true,
        gradientLine: false,
        cards: false,
        table: false,
        positions: false,
    },
    range: {
        matrixStrategy: false,
        matrixRange: true,
        matrixEv: false,
        matrixEq: false,
        matrixEqr: false,
        cells: true,
        detailMatrix: true,
        equityLine: false,
        gradientLine: true,
        cards: false,
        table: false,
        positions: false,
    },
    ev: {
        matrixStrategy: false,
        matrixRange: false,
        matrixEv: true,
        matrixEq: false,
        matrixEqr: false,
        cells: true,
        detailMatrix: true,
        equityLine: false,
        gradientLine: true,
        cards: false,
        table: false,
        positions: false,
    },
    eq: {
        matrixStrategy: false,
        matrixRange: false,
        matrixEv: false,
        matrixEq: true,
        matrixEqr: false,
        cells: true,
        detailMatrix: true,
        equityLine: false,
        gradientLine: true,
        cards: false,
        table: false,
        positions: false,
    },
    eqr: {
        matrixStrategy: false,
        matrixRange: false,
        matrixEv: false,
        matrixEq: false,
        matrixEqr: true,
        cells: true,
        detailMatrix: true,
        equityLine: false,
        gradientLine: true,
        cards: false,
        table: false,
        positions: false,
    },
    positions: {
        matrixStrategy: false,
        matrixRange: false,
        matrixEv: false,
        matrixEq: false,
        matrixEqr: false,
        cells: false,
        detailMatrix: false,
        equityLine: false,
        gradientLine: false,
        cards: false,
        table: false,
        positions: true,
    },
    text: {
        matrixStrategy: false,
        matrixRange: false,
        matrixEv: false,
        matrixEq: false,
        matrixEqr: false,
        cells: true,
        detailMatrix: false,
        equityLine: false,
        gradientLine: false,
        cards: false,
        table: false,
        positions: false,
    },
    cards: {
        matrixStrategy: false,
        matrixRange: false,
        matrixEv: false,
        matrixEq: false,
        matrixEqr: false,
        cells: false,
        detailMatrix: false,
        equityLine: false,
        gradientLine: false,
        table: true,
        cards: true,
        positions: false,
    },
};
